import React, {useState} from 'react';
import BtnWhite from '../Buttons/BtnWhite';
import BtnSubmit from '../Buttons/BtnSubmit';

const cookiesPrivacyPopup = (props) => {
  const [isShowCookiesPopup, setIsShowCookiesPopup] = useState(true);

  const acceptCookies = () => {
    if (window.localStorage) {
      localStorage.setItem('isCookiesAccepted', 'true');
      setIsShowCookiesPopup(false);
    }
  };

  let cookiesPopupComponent = (
    <div className='cookies_popup_container'>
      <div className='cookies_popup_inner'>
        <div className='content'>
          <p className='inner_text'>
           לידיעתך, אנו משתמשים בעוגיות (Cookies) באתר זה. &nbsp;
            <a className='additional-info-link' target='_blank' href={props.termsPolicyLink}>
              לפרטים נוספים
            </a>
          </p>
          <div className='btn-holder'>
            <BtnSubmit text='סגירה' onclick={() => acceptCookies()} />
          </div>
        </div>
      </div>
    </div>
  );

  return <div>{isShowCookiesPopup ? cookiesPopupComponent : null}</div>;
};
export default cookiesPrivacyPopup;
